import styled from 'styled-components';

export const CheckboxInput = styled.span`
  /* Create a custom checkbox */
  box-sizing: border-box;
  position: absolute;
  top: 5px;
  left: 0;
  height: 14px;
  width: 14px;
  background-color: inherit;
  border: 1px solid ${props => props.theme.primaryText};
  box-shadow: inset 0 1px 1px 0 rgba(0,0,0,0.1);

  /* Create the indicator (hidden when not checked) */
  &:after {
    content: "";
    display: none;
    position: absolute;
    top: 2px;
    left: 2px;
    width: 8px;
    height: 8px;
    background: ${props => props.theme.cyan};;
  }
`

export const CheckboxLabel = styled.label`
  /* Customize the label (the container) */
  display: block;

  position: relative;
  padding-left: ${props => props.theme.paddingSM};
  margin-bottom: ${props => props.theme.paddingXS};
  cursor: pointer;
  font-size: ${props => props.theme.fontSizeBase};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* Hide the browser's default checkbox */
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* On mouse-over, add a light cyan background color */
  &:hover input ~ ${CheckboxInput} {
    transition: all 0.2s ease-in-out;
    background-color: ${props => props.theme.hover};
  }

  /* Show the indicator when checked */
  input:checked ~ ${CheckboxInput}:after {
    display: block;
  }
`
